import { Helpers } from '../../helpers';
import { IWaterDisposalSystem } from '../../interfaces/iwater-disposal-system';
import { AssetTeam } from '../asset-team';
import { Asset } from '../asset';
import { Area } from '../area';

export class WaterDisposalSystemBase {
  WaterDisposalSystemId: number;
  Name: string;
  AssetID: number;
  Comments: string | null;
  AssetTeamId: number | null;
  WaterDisposalSystemAreaId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  Asset?: Asset;
  Area?: Area;

  constructor(item?: IWaterDisposalSystem) {
    if (item) {

      this.WaterDisposalSystemId = item.WaterDisposalSystemId;
      this.Name = item.Name;
      this.AssetID = item.AssetID;
      this.Comments = item.Comments;
      this.AssetTeamId = item.AssetTeamId;
      this.WaterDisposalSystemAreaId = item.WaterDisposalSystemAreaId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Asset = new Asset(item.Asset);
      this.Area = new Area(item.Area);
    }
  }
}